<template>
  <v-text-field
    v-model="date"
    :label="t.label"
    :placeholder="t.placeholder"
    mask="## / ##"
    :rules="rules"
    @blur="setExpDate()"
    @input="dateUpdated"
    required
    validate-on-blur
    class="flex-column"
  ></v-text-field>
</template>

<script>
import { VTextField } from "vuetify/lib";

export default {
  name: "NsCreditCardDate",
  components: {
    VTextField
  },
  props: {
    /**
     * Translations as a key:value object
     */
    translations: {
      type: Object,
      default() {
        return {
          label: "Expiration Date",
          placeholder: "MM / YY",
          fieldRequired: "Field is required",
          invalidDate: "Invalid Date Entered"
        };
      }
    }
  },
  data() {
    return {
      date: "",
      validDate: true,
      rules: [
        v => !!v || this.t.fieldRequired,
        v => this.isValidDate() || this.t.invalidDate
      ],
      expMonth: "",
      expYear: "",
      
    };
  },
  computed: {
    t() {
      return this.translations;
    }
  },
  methods: {
    dateUpdated() {
      this.$emit('cardDateUpdated', this.date);
    },
    setExpDate() {
      if (this.date.length === 4) {
        let today = new Date();
        let year = today.getFullYear().toString();
        let splitYear = year.match(/.{1,2}/g);
        let shortYear = parseInt(splitYear[1]);

        let expDate = this.date.match(/.{1,2}/g);
        let expMonth = parseInt(expDate[0]);
        let expYear = parseInt(expDate[1]);

        if (shortYear > expYear || (shortYear === expYear && today.getMonth() + 1 > expMonth)) {
          this.validDate = false;
        } else {
          this.validDate = true;
        }
      } else {
        this.validDate = false;
      }
    },
    isValidDate() {
      return this.validDate;
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

::v-deep * {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}
</style>
